var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjectImageActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.1819 16.3453L2.16523 16.362C1.94023 15.8703 1.79857 15.312 1.74023 14.6953C1.79857 15.3036 1.9569 15.8536 2.1819 16.3453Z",
    fill: "#1D1D1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53216 9.15417C8.62753 9.15417 9.5155 8.2662 9.5155 7.17083C9.5155 6.07547 8.62753 5.1875 7.53216 5.1875C6.4368 5.1875 5.54883 6.07547 5.54883 7.17083C5.54883 8.2662 6.4368 9.15417 7.53216 9.15417Z",
    fill: "#1D1D1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5223 2.16992H6.53893C3.5056 2.16992 1.69727 3.97826 1.69727 7.01159V13.9949C1.69727 14.9033 1.8556 15.6949 2.16393 16.3616C2.8806 17.9449 4.41393 18.8366 6.53893 18.8366H13.5223C16.5556 18.8366 18.3639 17.0283 18.3639 13.9949V12.0866V7.01159C18.3639 3.97826 16.5556 2.16992 13.5223 2.16992ZM17.0056 10.9199C16.3556 10.3616 15.3056 10.3616 14.6556 10.9199L11.1889 13.8949C10.5389 14.4533 9.48893 14.4533 8.83893 13.8949L8.5556 13.6616C7.96393 13.1449 7.02227 13.0949 6.3556 13.5449L3.23893 15.6366C3.0556 15.1699 2.94727 14.6283 2.94727 13.9949V7.01159C2.94727 4.66159 4.18893 3.41992 6.53893 3.41992H13.5223C15.8723 3.41992 17.1139 4.66159 17.1139 7.01159V11.0116L17.0056 10.9199Z",
    fill: "#1D1D1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectImageActive);
export default __webpack_public_path__ + "static/media/object_image_active.59f9ae190584d4d5926bb6c5c5be12f6.svg";
export { ForwardRef as ReactComponent };